<template>
  <div v-if="permission.companyWiseJobPlacement">
    <b-card title="Candidate List" no-body>
      <b-card-body>
        <b-row class="justify-content-between">
          <b-col cols="12" md="1"
                 class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="mr-1">Show</label>
            <Select
                v-model="search.paginate"
                :clearable="false"
            >
            <Option :value="10"> 10</Option>
            <Option :value="30"> 30</Option>
            <Option :value="50"> 50</Option>
            <Option :value="80"> 80</Option>
            <Option :value="100"> 100</Option>
            </Select>
          </b-col>
          <b-col cols="12" md="3">
            <DatePicker
                v-model="from_date"
                type="date"
                placeholder="Select From Date"
                style="width: 100%"
            >
            </DatePicker>
          </b-col>
          <b-col cols="12" md="3">
            <DatePicker
                v-model="to_date"
                type="date"
                placeholder="Select From Date"
                style="width: 100%"
            >
            </DatePicker>
          </b-col>
          <b-col cols="12" md="4">
            <Input
                v-model="search.search_data"
                class="d-inline-block mr-1"
                placeholder="Search name..."
                type="text"
            />
          </b-col>
        </b-row>
      </b-card-body>
      <div class="table-responsive">
        <table class="table">
          <thead>
          <tr>
            <th class="align-middle text-center">Sl</th>
            <th class="align-middle text-center">name</th>
            <th class="align-middle text-center">Applications</th>
            <th class="align-middle text-center">Schedule</th>
            <th class="align-middle text-center">Proposed Candidates</th>
            <th class="align-middle text-center">Pending Proposed Candidates</th>
            <th class="align-middle text-center">ShortListed Proposed Candidates</th>
            <th class="align-middle text-center">Interviewing Proposed Candidates</th>
            <th class="align-middle text-center">Selected Proposed Candidates</th>
            <th class="align-middle text-center">Rejected Proposed Candidates</th>
            <th class="align-middle text-center">Canceled Interview Proposed Candidates</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-if="companies.data.length"
              v-for="(company, index) in companies.data"
              :key="index"
              class="text-center"
          >
            <td class="align-middle text-center">
              {{ companies.from + index }}
            </td>
            <td class="align-middle text-center">
              <p>
                <b>{{ company.name ? company.name : "No data yet" }}</b>
              </p>
            </td>

            <td>
              {{ company.totalApplications ? company.totalApplications : "0" }}
            </td>

            <td>
              {{ company.totalSchedule ? company.totalSchedule : "0" }}
            </td>

            <td>
              {{ company.totalProposedCandidates ? company.totalProposedCandidates : "0" }}
            </td>

            <td>
              {{ company.totalPendingProposedCandidates ? company.totalPendingProposedCandidates : "0" }}
            </td>

            <td>
              {{ company.totalShortListedProposedCandidates ? company.totalShortListedProposedCandidates : "0" }}
            </td>

            <td>
              {{ company.totalInterviewingProposedCandidates ? company.totalInterviewingProposedCandidates : "0" }}
            </td>

            <td>
              {{ company.totalSelectedProposedCandidates ? company.totalSelectedProposedCandidates : "0" }}
            </td>

            <td>
              {{ company.totalRejectedProposedCandidates ? company.totalRejectedProposedCandidates : "0" }}
            </td>

            <td>
              {{ company.totalCancelInterviewProposedCandidates ? company.totalCancelInterviewProposedCandidates : "0" }}
            </td>
          </tr>

          <tr v-if="!companies.data.length">
            <td class="text-center" colspan="11">
              <h4>No data found!</h4>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <b-card-body>
        <div
            class="d-flex justify-content-between align-items-center"
            v-if="companies"
        >
              <span class="text-muted"
              >Showing {{ companies.from }} to {{ companies.to }} of
                {{ companies.total }} entries</span
              >
          <pagination
              :data="companies"
              @pagination-change-page="getResults"
              align="right"
              :show-disabled="true"
              :limit="10"
          ></pagination>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BCard,
  BCardBody,
  BFormFile,
} from "bootstrap-vue";
import _ from "lodash";

export default {
  data() {
    return {
      companies: {},
      search: {
        search_data: "",
        from_date: "",
        to_date: "",
        paginate: 10,
        page: 1,
      },
      from_date: "",
      to_date: "",
    };
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BCard,
    BCardBody,
    BFormFile,
  },

  mounted() {
    this.getResults();
  },
  computed: {
    permission() {
      return this.$store.getters.getPermissions.report;
    },
  },
  methods: {
    formatDate(date) {
      if (date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      return null;
    },

    getResults(page) {
      if (this.from_date) {
        this.search.from_date = this.formatDate(this.from_date);
      }
      if (this.to_date) {
        this.search.to_date = this.formatDate(this.to_date);
      }
      this.search.page = page == null ? this.search.page : page;
      const queryParams = this.buildQueryParamString(this.search);
      axios
          .post(`/app/report/company-wise-job-placement${queryParams}`)
          .then((res) => {
            this.companies = res.data.companies;
          })
          .catch((e) => {
            this.e(e.response.data.message);
          });
    },

    SearchData: _.debounce(function () {
      this.search.page = 1;
      this.getResults();
    }, 1000),

    paginateChange() {
      this.search.page = 1;
      this.getResults();
    },
  },
  watch: {
    "search.search_data": function () {
      this.SearchData();
    },
    "from_date": function () {
      this.SearchData();
    },
    "to_date": function () {
      this.SearchData();
    },
    "search.paginate": function () {
      this.paginateChange();
    },
  },
};
</script>

<style scoped>
p {
  margin: 0;
}

.padding {
  padding: 0.72rem 11px !important;
}
</style>
